import { useTranslate } from '@festina-life/ui/hooks'

import { Attribute } from '../../../attribute/Attribute'
import type { ChangesetOrigin } from './types'

type Props = {
  origin: ChangesetOrigin
}

export const ChangesetOriginIndicator = ({ origin }: Props) => {
  const translate = useTranslate()
  const originTranslations: Record<
    Exclude<ChangesetOrigin, 'branch'>,
    { indicator: string; title: string }
  > = {
    baseBranch: {
      indicator: translate('changesetList.origin.baseBranch.indicator'),
      title: translate('changesetList.origin.baseBranch.title'),
    },
    followedBranch: {
      indicator: translate('changesetList.origin.followedBranch.indicator'),
      title: translate('changesetList.origin.followedBranch.title'),
    },
  }

  if (origin === 'branch') {
    return null
  }

  const { indicator, title } = originTranslations[origin]

  return (
    <Attribute className="uppercase text-xs px-1!" title={title}>
      {indicator}
    </Attribute>
  )
}
